var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTemperatureCold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.728,
    height: 31.504,
    viewBox: "0 0 15.728 31.504",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "temperature-cold",
    transform: "translate(-7.272 -2.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_167373",
    "data-name": "Path 167373",
    d: "M11.25,22.707V17.9H9v4.806a3.375,3.375,0,1,0,2.25,0Z",
    transform: "translate(5)",
    fill: "#00a9e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_167374",
    "data-name": "Path 167374",
    d: "M15.75,20.405V7.875a5.625,5.625,0,1,0-11.25,0V20.4a7.875,7.875,0,1,0,11.25,0ZM10.125,31.5A5.632,5.632,0,0,1,4.5,25.875a5.53,5.53,0,0,1,1.209-3.442q.159-.2.336-.387c.058-.061.113-.125.174-.183q.187-.179.389-.34c.047-.038.091-.081.141-.118V7.875a3.375,3.375,0,1,1,6.75,0V21.4c.049.038.093.081.142.12.133.108.265.218.388.337.061.06.117.124.175.186.116.124.229.251.335.386a5.529,5.529,0,0,1,1.211,3.443A5.632,5.632,0,0,1,10.125,31.5Z",
    transform: "translate(5)",
    fill: "#b1b3b3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemperatureCold);
export default __webpack_public_path__ + "static/media/temperature-cold.19d46ba88fcad2aa1ea738a0cccb7831.svg";
export { ForwardRef as ReactComponent };